document.addEventListener('DOMContentLoaded', () => {
  const resultsBoxBackground = document.getElementById('desktopNavBackground');
  const desktopContent = document.getElementById('desktopNavContent');

  const menuItems = Array.from(document.querySelectorAll('.header-menu-item'));
  const menuContents = Array.from(document.querySelectorAll('.header-menu_item_content'));

  function isVisible(el) {
    return !!(el && (el.offsetWidth || el.offsetHeight || el.getClientRects().length));
  }

  function closeAllMenus() {
    menuContents.forEach(div => {
      div.style.display = 'none';
      div.classList.remove('is-active');
    });

    menuItems.forEach(li => li.classList.remove('active'));

    if (desktopContent) desktopContent.style.display = 'none';
    if (resultsBoxBackground) resultsBoxBackground.style.display = 'none';
  }

  function openMenu(contentDiv, menuItem) {
    closeAllMenus();

    contentDiv.style.display = 'block';
    contentDiv.classList.add('is-active');
    menuItem.classList.add('active');

    if (desktopContent) desktopContent.style.display = 'block';
    if (resultsBoxBackground) resultsBoxBackground.style.display = 'block';
  }

  // ✅ IMPORTANT: ensure everything starts closed
  closeAllMenus();

  menuItems.forEach(menuItem => {
    const menuId = menuItem.getAttribute('data-menu-id');
    if (!menuId) return;

    menuItem.addEventListener('click', (event) => {
      const link = event.target.closest('a.header-menu-link');
      if (!link) return;

      const href = link.getAttribute('href') || '';
      if (href && href !== '#') return;

      event.preventDefault();

      const contentDiv = document.getElementById(menuId);
      if (!contentDiv) return;

      const wasOpen = isVisible(contentDiv);
      wasOpen ? closeAllMenus() : openMenu(contentDiv, menuItem);
    });
  });

  // overlay click closes desktop menus
  if (resultsBoxBackground) {
    resultsBoxBackground.addEventListener('click', closeAllMenus);
  }

  // outside click closes desktop menus
  document.addEventListener('click', (event) => {
    const insideNav = event.target.closest('#site-header');
    const insideOverlay = resultsBoxBackground && event.target.closest('#desktopNavBackground');

    if (!insideNav && !insideOverlay) {
      closeAllMenus();
    }
  });

  /* ============================================================
     MOBILE SEARCH TOGGLE
     ============================================================ */

  const mobileSearchBtn = document.querySelector('.site-header-mobile-search-button');
  const searchWrapper = document.querySelector('.search-bar-wrapper');
  const siteMainDimmer = document.querySelector('.site-main-dimmer');

  function isMobile() {
    return window.matchMedia && window.matchMedia('(max-width: 989px)').matches;
  }

  function openMobileSearch() {
    if (!searchWrapper) return;

    searchWrapper.style.display = 'flex';
    searchWrapper.style.position = 'absolute';
    searchWrapper.style.top = '60px';
    searchWrapper.style.left = '0';
    searchWrapper.style.right = '0';
    searchWrapper.style.zIndex = '1100';

    if (siteMainDimmer) {
      siteMainDimmer.style.display = 'block';
    }

    // optional: close menus so the search isn't fighting nav
    closeAllMenus();

    // optional: focus input if it exists
    const input = searchWrapper.querySelector('input[type="search"], input[name="q"], input');
    if (input) input.focus();
  }

  function closeMobileSearch() {
    if (searchWrapper) {
      searchWrapper.style.display = 'none';
    }

    if (siteMainDimmer) {
      siteMainDimmer.style.display = 'none';
    }
  }

  function toggleMobileSearch() {
    if (!isMobile()) return;
    if (!searchWrapper) return;

    isVisible(searchWrapper) ? closeMobileSearch() : openMobileSearch();
  }

  // tap icon toggles search (mobile only)
  if (mobileSearchBtn) {
    mobileSearchBtn.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      e.stopPropagation(); // prevents the document click closer firing immediately
      toggleMobileSearch();
    });
  }

  // tap dimmer closes search + hides dimmer
  if (siteMainDimmer) {
    siteMainDimmer.addEventListener('click', (e) => {
      if (!isMobile()) return;
      e.preventDefault();
      closeMobileSearch();
      closeAllMenus(); // optional consistency
    });
  }

  // tap outside closes search (mobile only)
  document.addEventListener('click', (e) => {
    if (!isMobile()) return;
    if (!searchWrapper || !mobileSearchBtn) return;

    const insideSearch = e.target.closest('.search-bar-wrapper');
    const insideBtn = e.target.closest('.site-header-mobile-search-button');

    if (!insideSearch && !insideBtn) {
      closeMobileSearch();
    }
  });

  // ESC closes both desktop menus + mobile search
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAllMenus();
      closeMobileSearch();
    }
  });

  // rotate/resize up to desktop => hide mobile search + dimmer
  window.addEventListener('resize', () => {
    if (!isMobile()) closeMobileSearch();
  });
});
